import axios from 'axios';
import { i18n } from '@/i18n';

let fetchPromise = null;

/**
 * Fetches the user's language from the API and applies it to i18n, localStorage, and axios.
 * Concurrent callers share one in-flight request. Pass `{ force: true }` after login
 * so the preference is reloaded with the new auth session.
 */
export async function fetchUserLanguage({ force = false } = {}) {
  if (!force && fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const { data } = await axios.get('/api/get-language');
      const code = data.message === 'hu' ? 'hu' : 'en';
      localStorage.setItem('locale', code);
      axios.defaults.headers.common['locale'] = code;
      i18n.global.locale.value = code;
      return code;
    } catch (_) {
      fetchPromise = null;
      return localStorage.getItem('locale') ?? 'en';
    }
  })();

  return fetchPromise;
}
